export { default } from './ImatgeTextBoto';
